import { hasMinimumRole } from '@snap-types/features/user';
import { UserRole } from '@snap-types/models/enums';
import { ErrorUnauthorized } from '@ui/components/Errors/ErrorUnauthorized';
import { useAuth } from '@ui/state/auth';

export const WithPermission = ({
  children,
  minimumRole,
  showUnauthorized = false,
}: {
  children: React.ReactNode;
  minimumRole: UserRole;
  showUnauthorized?: boolean;
}) => {
  const { user } = useAuth();

  if (!user) {
    console.warn('WithPermission: expected user to be defined');
    return null;
  }

  if (!minimumRole || !Object.values(UserRole).includes(minimumRole)) {
    console.warn('WithPermission: missing component permissions');
    return null;
  }

  if (hasMinimumRole({ minimumRole, user })) {
    return <>{children}</>;
  }

  return showUnauthorized ? <ErrorUnauthorized /> : null;
};
